function mixImmediate(a, b) {
  return function (p) {
    return p > 0 ? b : a;
  };
}
export { mixImmediate };